export default (key = "", value = {}, expiry = new Date(), domain = "") => {
  document.cookie = `BWAMICRO:user=${JSON.stringify(
    value
  )}; expires=${expiry.toUTCString()}; path:/; ${domain}`;
};
